<script lang="ts">
  import { _ } from 'svelte-i18n';

  import mbdImpressum from '../../assets/MBD_Impressum_Stand_11-2025.pdf';
  import mbdDatenschutz from '../../assets/MBD_Datenschutz_Stand_11-2025.pdf';
  import mbdHaftungsauschluss from '../../assets/MBD_Haftungsausschluss_Stand_11-2025.pdf';
  import mbdParticipation from '../../assets/MBD_Teilnahmebedingungen_Stand_09-2025.pdf';
  import ContactUs from './contact-us.svelte';
  import ThankYouModal from './thank-you-modal.svelte';

  let showContactUs = false;
  let showThankyouMessage = false;

  // export let isAppActive = true;
  export let isStartingInFuture = false;
</script>

{#if showContactUs && !showThankyouMessage}
  <ContactUs bind:showContactUs bind:showThankyouMessage />
{:else if showThankyouMessage}
  <ThankYouModal bind:showContactUs bind:showThankyouMessage />
{/if}

<div class="bg-black py-3 sm:py-4">
  <div class="mx-auto max-w-7xl px-3 sm:px-6">
    <div
      class="flex flex-col items-center justify-center gap-2 text-center sm:flex-col sm:gap-3"
    >
      <div
        class="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center"
      >
        {#if !isStartingInFuture}
          <a
            href={mbdImpressum}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
            data-umami-event="Download - Impressum">{$_('Impressum')}</a
          >

          <span class="hidden text-white sm:inline">•</span>

          <a
            href={mbdDatenschutz}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
            data-umami-event="Download - Datenschutz">{$_('Datenschutz')}</a
          >

          <span class="hidden text-white sm:inline">•</span>

          <a
            href={mbdHaftungsauschluss}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
            data-umami-event="Download - Haftungsauschluss"
            >{$_('Haftungsausschluss')}</a
          >

          <span class="hidden text-white sm:inline">•</span>

          <a
            href={mbdParticipation}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
            data-umami-event="Download - Teilnahmebedingungen"
            >{$_('Terms and Conditions')}</a
          >
        {/if}

        <span class="hidden text-white sm:inline">•</span>

        <button
          on:click={() => (showContactUs = true)}
          class="text-xs text-white transition-colors duration-200 hover:text-gray-300 sm:text-sm"
          data-umami-event="Contact Us"
        >
          {$_('Contact Us')}
        </button>
      </div>
    </div>
  </div>
</div>
